// extracted by mini-css-extract-plugin
export default {"root":"modal_root__8qjfP","wrapper":"modal_wrapper__GfTEz","large":"modal_large__h0obJ","closeButton":"modal_closeButton__ZCwkj"};